/* User-authorized three-channel contact dock. The existing Shopify Inbox
   activator remains the backend; no messages are composed or sent here. */
(() => {
 'use strict';
 const dock = document.querySelector('[data-hp-contact]');
 const toggle = dock?.querySelector('.a-contact-toggle');
 const channels = dock ? [...dock.querySelectorAll('[data-a-contact-channel]')] : [];
 if (dock) dock.dataset.aContactOpen = 'true';
 if (toggle) {toggle.hidden = true;toggle.tabIndex = -1;toggle.setAttribute('aria-hidden','true');}
 dock?.addEventListener('keydown', event => {
  if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
  const current = channels.indexOf(document.activeElement);
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? channels.length - 1 : (current + (event.key === 'ArrowDown' ? 1 : -1) + channels.length) % channels.length;
  event.preventDefault();channels[next]?.focus({preventScroll:true});
 });

 // Observe only public/open Inbox DOM. Style the duplicate activator, never
 // hide/disable the provider widget or its actual chat panel.
 const observed = new WeakSet();
 let scheduled = false, pendingAction = null;
 const chatRoots = () => {
  const roots = [...document.querySelectorAll('shopify-chat')].map(w=>w.shadowRoot).filter(Boolean);
  for (let i=0;i<roots.length;i++) for (const node of roots[i].querySelectorAll('*')) if (node.shadowRoot) roots.push(node.shadowRoot);
  return roots;
 };
 const launcher = () => chatRoots().map(root=>root.querySelector('button.activator')).find(Boolean);
 const setStyle = (node,key,value,priority='') => {
  if (node.style.getPropertyValue(key)!==value || node.style.getPropertyPriority(key)!==priority) node.style.setProperty(key,value,priority);
 };
 const observe = root => {
  if (observed.has(root)) return;
  observed.add(root);
  new MutationObserver(schedule).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['class','style','tabindex']});
 };
 function schedule() {
  if (scheduled) return;
  scheduled=true;
  requestAnimationFrame(()=>{scheduled=false;syncInbox();});
 }
 function syncInbox() {
  if (!dock) return;
  const roots=chatRoots();
  for (const root of roots) {
   observe(root);
   if (!root.querySelector('style[data-hp-inbox-dock]')) {
    const style=document.createElement('style');style.dataset.hpInboxDock='true';
    style.textContent='button.activator,.activator-nudge{opacity:0!important;pointer-events:none!important}';
    root.append(style);
   }
   root.querySelectorAll('button.activator').forEach(button=>{
    setStyle(button,'visibility','visible');setStyle(button,'opacity','0','important');setStyle(button,'pointer-events','none','important');
    if (button.tabIndex!==-1) button.tabIndex=-1;
   });
   if (root.host.matches('shopify-agent-runtime')) setStyle(root.host,'pointer-events','none');
   root.querySelectorAll('#shopify-element-wrapper,.activator-nudge').forEach(node=>setStyle(node,'pointer-events','none'));
   root.querySelectorAll('.panel,.new-chat-popover').forEach(node=>setStyle(node,'pointer-events','auto'));
  }
  document.querySelectorAll('shopify-chat').forEach(widget=>setStyle(widget,'pointer-events','none'));
  const button=launcher();
  dock.dataset.nativeChatReady=button?'true':'loading';
  if (pendingAction && button) {
   const action=pendingAction;pendingAction=null;
   setTimeout(()=>{button.click();action.dataset.nativeChatOpened='true';},0);
  }
 }
 document.addEventListener('click',event=>{
  const action=event.target.closest?.('[data-am-chat]');
  if (!action || !dock) return;
  event.preventDefault();event.stopImmediatePropagation();
  pendingAction=action;syncInbox();
 },true);
 new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
 // Shadow roots can attach to an existing provider host without a light-DOM
 // mutation. Keep lifecycle discovery active after the old 30-second window.
 setInterval(schedule,1000);
 syncInbox();
 document.addEventListener('click',event=>{
  const nativeClose=event.composedPath().find(node=>node instanceof Element&&node.matches('button[aria-label="Close chat"]'));
  if (nativeClose) setTimeout(()=>{schedule();const action=document.getElementById('a-contact-chat');if(action&&getComputedStyle(action).visibility!=='hidden')action.focus({preventScroll:true});},100);
 },true);

  // The frozen sticky inquiry action has no trailing decorative arrow.
  document.querySelectorAll('[data-pdp-a] .ab-sticky .ab-button').forEach(button => {
    const text = button.lastChild;
    if (text?.nodeType === Node.TEXT_NODE) text.textContent = text.textContent.replace(/\s*→\s*$/, '');
  });

  const root = document.getElementById('categories'), track = root?.querySelector('#catTrack');
  const pagination = root?.querySelector('[data-hp-category-pages]');
  if (!track || !pagination) return;
  const cards = [...track.querySelectorAll('.cat-card')], buttons = [...pagination.querySelectorAll('[data-hp-category-page]')];
  const targets = () => {
    const max = Math.max(0, track.scrollWidth - track.clientWidth);
    return buttons.map((_, page) => Math.min(max, cards[page * 2].offsetLeft - cards[0].offsetLeft));
  };
  const sync = () => {
    const offsets = targets();let active = 0;
    offsets.forEach((left, page) => {if (Math.abs(track.scrollLeft - left) < Math.abs(track.scrollLeft - offsets[active])) active = page;});
    buttons.forEach((button, page) => {if (page === active) button.setAttribute('aria-current', 'true');else button.removeAttribute('aria-current');});
  };
  buttons.forEach((button, page) => button.addEventListener('click', () => track.scrollTo({left:targets()[page],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
  track.addEventListener('scroll', sync, {passive:true});
  track.addEventListener('scrollend', sync);
  track.addEventListener('category-drag-end', sync);
  if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
  sync();
})();
